import React from 'react';
import { PropTypes } from 'prop-types';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCircleNotch } from '@fortawesome/free-solid-svg-icons';

const LoadingSpinnerIcon = ({ fill = '#246EFF', size = '2x', style }) => (
    <FontAwesomeIcon spin icon={faCircleNotch} color={fill} size={size} style={style} />
);

LoadingSpinnerIcon.propTypes = {
    fill: PropTypes.string,
    size: PropTypes.string,
    style: PropTypes.object,
};

export default LoadingSpinnerIcon;
